import React, { useState } from "react"
import { ClienteInfo } from "../cliente-info";
// import { useModal } from "../../../../../hooks/ModalContext";
import { useDividas } from "../../../../../context/DividasContext";
import { usePropostas } from "../../../../../context/PropostasContext";
import { Radio } from "../../../../generics/radio";
import { Contrato } from './components/contratos'
import { format } from "date-fns";

export const ContraProposta = () => {
  // const { setModal, modalInfo, onClose } = useModal();
  const { devedorCadastro, devedor } = useDividas()
  const { setFormaPagamnento, formaPagamento } = usePropostas()

  const dataAtual = new Date()

  const [tipo, setTipo] = useState('AV')


  return (
    <div className="flex max-h-full flex-col items-center px-2">

      {
        !devedor?.cpf_cnpj && !devedorCadastro?.dadoscadastrais && devedor !== null ? <div className="w-full text-center text-primary font-bold">
          <h3>Clique duas vezes em um dos devedores ao lado para iniciar o atendimento!</h3>
        </div> : !devedorCadastro?.dadoscadastrais && devedor === null ?
          <div className="w-full text-center text-primary font-bold">
            <h3>Esse cliente nao está cadastrado em nosso banco de dados!</h3>
          </div>
          :
          (
            <>
              <ClienteInfo />

              {/*  border-2 border-gray-300 rounded-md h-10 w-10 */}
              <div className="m-1 w-full ">

                <div className="flex items-center w-full my-4  px-4 gap-8">
                  <div className="flex flex-col ">
                    <p className="font-medium text-sm">Tipo:</p>
                    <div className="flex items-center gap-2 p-2">
                      <Radio name="tipo" sizeText="text-xs" label="AV" checked={tipo === "AV"} onChange={() => setTipo('AV')} />
                      <Radio name="tipo" sizeText="text-xs" label="AP" checked={tipo === 'AP'} onChange={() => setTipo("AP")} />
                    </div>
                  </div>

                  <div className="flex flex-col w-[70%]">
                    <p className="font-medium my-1 text-sm">Forma Pagamento: </p>
                    <select className="w-full bg-gray-200 p-2" value={formaPagamento} onChange={(e) => setFormaPagamnento(e.target.value)}>
                      <option value="Boleto">Boleto</option>
                      <option value="PIX">PIX</option>
                    </select>
                  </div>


                  <div>
                    <p className=" font-medium my-1  text-sm">Vencimento:</p>
                    <input type="date" name="" id="" className="border-2 rounded-sm py-1 px-2" min={format(dataAtual, 'yyyy-MM-dd')} />
                  </div>
                </div>

                <div>
                  <Contrato />
                </div>

                <div className="flex items-start gap-2 w-full text-sm">
                  <div className="w-full  flex items-center flex-col justify-between ">
                    <h5 className="underline text-primary w-[85%] text-start">Valores da divida</h5>
                    {/* Valores da divida */}
                    <div className="flex items-center justify-between my-2 gap-2 w-[85%]">
                      <p className="w-[90%]">Valor Original</p>
                      <div className="w-[60%] rounded-md bg-blue-200 px-2 py-1">
                        <p>R$ 2.000,00</p>
                      </div>
                    </div>
                    <div className="flex items-center justify-between my-2 gap-2 w-[85%]">
                      <p className="w-[90%]">Valor Juros</p>
                      <div className="w-[60%] rounded-md bg-blue-200 px-2 py-1">
                        <p>R$ 2.000,00</p>
                      </div>
                    </div>
                    <div className="flex items-center justify-between my-2 gap-2 w-[85%]">
                      <p className="w-[90%]">Valor Multa</p>
                      <div className="w-[60%] rounded-md bg-blue-200 px-2 py-1">
                        <p>R$ 2.000,00</p>
                      </div>
                    </div>
                    <div className="flex items-center justify-between my-2 gap-2 w-[85%]">
                      <p className="w-[90%]">Valor Encargos</p>
                      <div className="w-[60%] rounded-md bg-blue-200 px-2 py-1">
                        <p>R$ 2.000,00</p>
                      </div>
                    </div>
                    <div className="flex items-center justify-between my-2 gap-2 w-[85%]">
                      <p className="w-[90%]">Valor Atualizados</p>
                      <div className="w-[60%] rounded-md bg-blue-200 px-2 py-1">
                        <p>R$ 2.000,00</p>
                      </div>
                    </div>
                  </div>

                  <div className="w-full  flex items-center flex-col justify-between ">
                    <h5 className="underline  text-primary w-[85%] text-start">Valores da proposta</h5>
                    {/* Valores da proposta */}
                    {
                      tipo === 'AV' ? (
                        <>             <div className="flex items-center justify-between my-2 gap-2 w-[85%]">
                          <p className="w-[90%]">Valor Desconto</p>
                          <div className="w-[60%] rounded-md bg-blue-200 px-2 py-1">
                            <p>R$ 2.000,00</p>
                          </div>
                        </div>
                          <div className="flex items-center justify-between my-2 gap-2 w-[85%]">
                            <p className="w-[90%]">Valor Final Proposta</p>
                            <div className="w-[60%] rounded-md bg-blue-200 px-2 py-1">
                              <p>R$ 2.000,00</p>
                            </div>
                          </div>

                        </>
                      ) : (
                        <>
                          <div className="flex items-center justify-between my-2 gap-2 w-[85%]">
                            <p className="w-[90%]">Valor Desconto</p>
                            <div className="w-[60%] rounded-md bg-blue-200 px-2 py-1">
                              <p>R$ 2.000,00</p>
                            </div>
                          </div>
                          <div className="flex items-center justify-between my-2 gap-2 w-[85%]">
                            <p className="w-[90%]">Valor Entrada</p>
                            <div className="w-[60%] rounded-md bg-blue-200 px-2 py-1">
                              <p>R$ 2.000,00</p>
                            </div>
                          </div>
                          <div className="flex items-center justify-between my-2 gap-2 w-[85%]">
                            <p className="w-[90%]">Qtd Parcelas</p>
                            <div className="w-[60%] rounded-md bg-blue-200 px-2 py-1">
                              <p>6</p>
                            </div>
                          </div>
                          <div className="flex items-center justify-between my-2 gap-2 w-[85%]">
                            <p className="w-[90%]">Valor Parcelas</p>
                            <div className="w-[60%] rounded-md bg-blue-200 px-2 py-1">
                              <p>R$ 2.000,00</p>
                            </div>
                          </div>
                          <div className="flex items-center justify-between my-2 gap-2 w-[85%]">
                            <p className="w-[90%]">Valor Final Proposta</p>
                            <div className="w-[60%] rounded-md bg-blue-200 px-2 py-1">
                              <p>R$ 2.000,00</p>
                            </div>
                          </div>
                        </>
                      )
                    }

                  </div>
                </div>
                <div>
                  <p>Justificativa</p>
                  <textarea name="" id="" maxLength={500} className="px-4 py-2 w-full h-14 border-2 rounded-md resize-none text-sm"></textarea>
                </div>
              </div>
            </>
          )
      }

    </div>
  )
}

